import i18n, { TFunction } from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import intervalPlural from 'i18next-intervalplural-postprocessor'

import { ALL_LANGUAGES, BrowserStorage, Instance, ALL_LANGUAGES_WO_RUSSIAN, Languages, lookupLocalStorage, NS } from '@const/consts'
import * as Sentry from '@sentry/browser'
import { SeverityLevel } from '@sentry/types'

export const getInstanceWoState = () => {
  return window.location.hostname.match(/com.br|ilsbrasil.com/g)
    ? Instance.BRASIL
    : window.location.hostname.match(/ilsglobal.vn/g)
      ? Instance.VIETNAMESE
      : window.location.hostname.match(/metrofile.co.za|metrofile.co.ke|africa/g)?.[0]
        ? Instance.SOUTH_AFRICA
        : (window.location.hostname.match(/global|ru/g)?.[0] ?? window.localStorage.getItem(BrowserStorage.INSTANCE) ?? Instance.GLOBAL);
};

const instance = getInstanceWoState();
window.localStorage.setItem(BrowserStorage.INSTANCE, instance);

const isRussia = instance === Instance.RUSSIAN
const lngFromLS = window.localStorage.getItem(lookupLocalStorage) ?? Languages.EN;

let translates: string[] = ALL_LANGUAGES_WO_RUSSIAN

if (isRussia) {
  translates = ALL_LANGUAGES
}

const finalLanguage = !isRussia && lngFromLS === Languages.RU ? Languages.EN : lngFromLS;

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .use(intervalPlural)
  .init({
    lng: finalLanguage,
    fallbackLng: translates,
    preload: translates,
    ns: NS,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    debug: false,

    react: {
      nsMode: 'default'
    },

    interpolation: {
      escapeValue: false
    }
  })
  .catch((err: TFunction) => {
    const errorText = 'i18n error'
    const errorLevel: SeverityLevel = 'fatal'
    const errorInfo = { err }

    Sentry.withScope((scope: Sentry.Scope) => {
      scope.setLevel(errorLevel)
      scope.setExtras(errorInfo)
      Sentry.captureException(new Error(errorText))
    })
  })

export default i18n
